var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Texture } from "three";
var CancellationToken = /** @class */ (function () {
    function CancellationToken() {
        this.listeners = [];
        this.cancelled = false;
    }
    CancellationToken.prototype.cancel = function () {
        var e_1, _a;
        this.cancelled = true;
        try {
            for (var _b = __values(this.listeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                var l = _c.value;
                l();
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.listeners = [];
    };
    CancellationToken.prototype.addCancelListener = function (l) {
        if (this.cancelled) {
            l();
        }
        else {
            this.listeners.push(l);
        }
    };
    CancellationToken.prototype.removeCancelListener = function (l) {
        this.listeners.splice(this.listeners.indexOf(l), 1);
    };
    return CancellationToken;
}());
export { CancellationToken };
export function loadTexture(texture, cancellationToken) {
    return new Promise(function (resolve, reject) {
        var img = document.createElement("img");
        img.crossOrigin = "use-credentials";
        img.src = texture;
        img.onload = function () {
            resolve(new Texture(img));
        };
        cancellationToken.addCancelListener(function () {
            reject(new Error("Promise cancelled"));
            img.src = "";
        });
    });
}
var PriorityLoader = /** @class */ (function () {
    function PriorityLoader(maxParallelTasks) {
        this.maxParallelTasks = maxParallelTasks;
        this.pendingTasks = [];
        this.runningTasks = [];
    }
    PriorityLoader.prototype.queue = function (task) {
        this.pendingTasks.push(task);
        this.pendingTasks.sort(function (a, b) { return a.priority - b.priority; });
        this.checkNext();
    };
    PriorityLoader.prototype.queuePromise = function (run, priority) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.queue({
                priority: priority,
                run: function () { return __awaiter(_this, void 0, void 0, function () {
                    var _a, e_2;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                _a = resolve;
                                return [4 /*yield*/, run()];
                            case 1:
                                _a.apply(void 0, [_b.sent()]);
                                return [3 /*break*/, 3];
                            case 2:
                                e_2 = _b.sent();
                                reject(e_2);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                }); },
            });
        });
    };
    PriorityLoader.prototype.checkNext = function () {
        var _this = this;
        if (this.runningTasks.length >= this.maxParallelTasks)
            return;
        var task = this.pendingTasks.shift();
        if (task == null)
            return;
        this.runningTasks.push(task);
        var endTask = function () {
            _this.runningTasks.splice(_this.runningTasks.indexOf(task), 1);
            _this.checkNext();
        };
        task.run().then(endTask, endTask);
    };
    return PriorityLoader;
}());
export { PriorityLoader };
